
import axios from 'axios';
import Order from '../models/Order';


/**
 * StripeGateway constructor
 * @class
 */
class StripeGateway
{
    /**
     * StripeGateway constructor
     * @constructor
     */
    constructor()
    {
        this.card = null;
        this.stripe = Stripe( 'pk_live_PRod3io8MR8zZbD1lxtE6CIv00qNANobrV' );
    }


    /**
     *
     */
    mount( placeholder )
    {
        const elements = this.stripe.elements();

        const style = {
            base: {
                color: '#32325d',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '13.5px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        this.card = elements.create( 'card', {
            hidePostalCode: true,
            style,
        });

        this.card.mount( placeholder );
    }


    /**
     *
     * @param {Order} order
     */
    process( order )
    {
        return this.stripe.createPaymentMethod( 'card', this.card,
            {
                billing_details:
                {
                    name: order.billing.fullname,
                    address:
                    {
                        line1: order.billing.line1,
                        line2: order.billing.line2,
                        city: order.billing.city,
                        state: order.billing.county,
                        postal_code: order.billing.postcode,
                        country: order.billing.country,
                    },
                },
            }
        ).then( response => {
            if( response.error )
                return Promise.reject( response.error.message );

            order.stripe_card_id = response.paymentMethod.id;
            return order.process().then( r => this.handleResponse( order, r ) );
        });
    }


    handleResponse( order, response )
    {
        if( response.error ) {
            // Show error from server on payment form
            return Promise.reject( response.error );
        } else if( response.requires_action ) {
            // Use Stripe.js to handle required card action
            return this.stripe.handleCardAction(
                response.payment_intent_client_secret
            ).then( response => {
                if( response.error ) {
                    return Promise.reject( response.error );
                } else {
                    // The card action has been handled
                    // The PaymentIntent can be confirmed again on the server
                    return axios.post( `/api/order/${ order.order_id }/purchase`, {
                        payment_intent_id: response.paymentIntent.id,
                    }).then( response => this.handleResponse( order, response.data ) );
                }
            });
        } else {
            order = new Order( response.data.order, true );
            return Promise.resolve( order );
        }
    }
}

export default StripeGateway;
